import { useMemo } from "react";
import { SliderSideEnum } from "store/retrotagSlice";
import { useSelector } from "store/useSelector";
import type { TimeRangeFinite } from "types/types";

/** The currently selected range queued for applying a retrotag */
export function useRetrotagSegmentRange(): TimeRangeFinite | null {
  return useSelector(state => state.retrotag.retrotagSegmentRange);
}

export function useRetrotagTagPath(): string[] {
  return useSelector(state => state.retrotag.tagPath);
}

export function useIsRetrotagPopperOpen(processId: string | null): boolean {
  const isPopperOpen = useSelector(
    state => state.retrotag.isRetrotagPopperOpen
  );
  const retrotagProcessId = useSelector(
    state => state.retrotag.retrotagProcessId
  );
  return useMemo(
    () => Boolean(isPopperOpen && processId && retrotagProcessId === processId),
    [isPopperOpen, processId, retrotagProcessId]
  );
}

/** If a segment selector slider is currently pressed by the user, sliderSideCurrentlyPressed indicates the "left" or "right" slider  */
export function useSliderSideCurrentlyPressed(): SliderSideEnum | null {
  return useSelector(state => state.retrotag.sliderSideCurrentlyPressed);
}
